import React, { Component } from 'react';
import { func, bool } from 'prop-types';
import { connect } from 'react-redux';
import { questionTypeValues, SurveySchemaPartItemEditorType } from '../../../../constants/types';
import { updateSchemaPartItemAction } from '../../../../actions';
import editorStyles from '../../editor.module.css';
import { LocalizedTextArea } from '../../../LocalizedInput';
import TextInput from '../../../TextInput';
import { withLang } from '../../../../i18n';
import SelectionQuestionEditor from './SelectionQuestionEditor';

class Question extends Component {
  constructor(props) {
    super(props);

    this.onQuestionPropertyChanged = this.onQuestionPropertyChanged.bind(this);
    this.onLocalizedQuestionInputChange = this.onLocalizedQuestionInputChange.bind(this);
    this.renderActions = this.renderActions.bind(this);
    this.renderQuestionBody = this.renderQuestionBody.bind(this);
    this.renderTextField = this.renderTextField.bind(this);
    this.renderEditor = this.renderEditor.bind(this);

    this.state = {
      itemIndex: this.props.item.order - 1
    };
  }

  onQuestionPropertyChanged(event) {
    let { value } = event.target;
    if (event.target.type === 'checkbox') {
      value = event.target.checked;
    }
    this.props.dispatchUpdateItem(this.state.itemIndex, {
      question: { [event.target.name]: value }
    });
  }

  onLocalizedQuestionInputChange(lang) {
    return (event) => this.props.dispatchUpdateItem(this.state.itemIndex, {
      question: {
        [event.target.name]: { [lang]: event.target.value }
      }
    });
  }

  renderActions() {
    const { item, translate: t } = this.props;
    return (
      <div className={editorStyles.itemActions}>
        <div className={`formItem ${editorStyles.headerInput}`}>
          <input
            name="required"
            id={`required_${this.state.itemIndex}`}
            type="checkbox"
            checked={item.question.required}
            onChange={this.onQuestionPropertyChanged}
            disabled={this.props.lockedFromEditing}
          />
          <label className={editorStyles.checkbox} htmlFor={`required_${this.state.itemIndex}`} data-cy="required-question-checkbox">
            {t('surveyParts.required')}
          </label>
        </div>
        <div className={`formItem ${editorStyles.headerInput}`}>
          <label className={editorStyles.textInput} htmlFor={`code_${this.state.itemIndex}`}>
            {t('surveyParts.identifier')}
          </label>
          <TextInput
            id={`code_${this.state.itemIndex}`}
            name="code"
            value={item.question.code}
            onChange={this.onQuestionPropertyChanged}
            maxLength={255}
            disabled={this.props.lockedFromEditing}
            dataCy="survey-schema-part-open-question-identifier-input"
          />
        </div>
        <button
          type="button"
          className="actionButton icon--trash iconRemove"
          onClick={this.props.onRemove}
          title={t('common.remove')}
          disabled={this.props.lockedFromEditing}
        />
      </div>
    );
  }

  renderQuestionBody() {
    switch (this.props.item.question.type) {
      case questionTypeValues.TEXT_FIELD:
        return this.renderTextField();
      case questionTypeValues.DROPDOWN:
        return this.renderEditor('surveyParts.dropdown');
      case questionTypeValues.RADIO_BUTTON_GROUP:
        return this.renderEditor('surveyParts.radioButtonGroup');
      case questionTypeValues.CHECKBOX_GROUP:
        return this.renderEditor('surveyParts.checkboxGroup');
      default:
        return null;
    }
  }

  renderTextField() {
    const { item } = this.props;
    return (
      <LocalizedTextArea
        name="text"
        values={item.question.text}
        onInputChange={this.onLocalizedQuestionInputChange}
        placeholderTranslationNamespace="inLanguage"
        dataCyPrefix="survey-schema-part-open-question-text-area"
      />
    );
  }

  renderEditor(translationNamespace) {
    return (
      <SelectionQuestionEditor
        item={this.props.item}
        translationNamespace={translationNamespace}
        dispatchUpdateItem={this.props.dispatchUpdateItem}
        lockedFromEditing={this.props.lockedFromEditing}
      />
    );
  }

  render() {
    return (
      <div>
        {this.renderActions()}
        {this.renderQuestionBody()}
      </div>
    );
  }
}

Question.propTypes = {
  item: SurveySchemaPartItemEditorType.isRequired,
  onRemove: func.isRequired,
  dispatchUpdateItem: func.isRequired,
  lockedFromEditing: bool.isRequired,
  translate: func.isRequired
};

const mapDispatchToProps = (dispatch) => ({
  dispatchUpdateItem: (index, item) =>
    dispatch(updateSchemaPartItemAction(index, item))
});

export default withLang(connect(null, mapDispatchToProps)(Question));
